export function transformFiltersForUrl(rawFilters, fieldConfig = {}) {
  const transformedFilters = {};
  const orConditions = {};

  Object.entries(rawFilters).forEach(([key, value]) => {
    if (key === "$and" || key === "$or") {
      if (Array.isArray(value)) {
        transformedFilters[key] = value.map((condition) => {
          if (typeof condition === "object" && condition !== null) {
            return transformFiltersForUrl(condition, fieldConfig);
          }
          return condition;
        });
      }
      return;
    }

    // Se o valor já for um operador ($eq, $ne, etc), manter como está e pular para o próximo
    if (
      typeof value === "object" &&
      value !== null &&
      Object.keys(value).some((op) => op.startsWith("$"))
    ) {
      transformedFilters[key] = value;
      return;
    }

    // --- Tratamento EXCLUSIVO para campos de STATUS (deleted_at, active) ---
    if (key.endsWith("deleted_at")) {
      if (value === false || value === "false") {
        transformedFilters[key] = { $eq: "null" };
      } else if (value === true || value === "true") {
        transformedFilters[key] = { $ne: "null" };
      }
      return;
    }

    // --- Tratamento EXCLUSIVO para campos de ID ---
    if (key.endsWith("_id") && typeof value === "boolean") {
      if (value === false || value === "false") {
        transformedFilters[key] = { $eq: "null" };
      } else if (value === true) {
        transformedFilters[key] = { $ne: "null" };
      }
      return;
    }

    if (key === "active") {
      if (value === 0 || value === "0") {
        transformedFilters.active = { $eq: 0 };
      } else if (value === 1) {
        transformedFilters.active = { $eq: 1 };
      }
      return;
    }

    // --- Tratamento EXCLUSIVO para campos de [maintenance_created_movement, is_asset, was_billed, is_completed] ---
    if (
      key.endsWith("maintenance_created_movement") ||
      key.endsWith("is_asset") ||
      key.endsWith("was_billed") ||
      key.endsWith("is_completed")
    ) {
      const normalizedValue =
        value === true || value === "true" || value === 1 || value === "1";

      const normalizedFalse =
        value === false || value === "false" || value === 0 || value === "0";

      if (normalizedFalse) {
        transformedFilters[key] = { $eq: 0 };
      } else if (normalizedValue) {
        transformedFilters[key] = { $eq: 1 };
      }
      return;
    }

    // --- Tratamento genérico para campos AutoComplete ou simples ---
    const valuesToProcess = [];
    let isAutoCompleteField = false;

    const propertyToExtract =
      fieldConfig[key] ?? // 1. configuração explícita da tela
      (key === "id" || key.endsWith("_id") // 2. fallback padrão
        ? "value"
        : "label");

    if (Array.isArray(value)) {
      isAutoCompleteField = true;
      value.forEach((item) => {
        let val;
        if (
          typeof item === "object" &&
          item !== null &&
          item[propertyToExtract] !== undefined
        ) {
          val = String(item[propertyToExtract]);
        } else {
          val = String(item);
        }

        if (key === "cpf_cnpj") {
          val = val.replace(/\D/g, "");
        }

        if (val.trim() !== "") {
          valuesToProcess.push(val.trim());
        }
      });
    } else if (
      typeof value === "object" &&
      value !== null &&
      value[propertyToExtract] !== undefined
    ) {
      isAutoCompleteField = true;
      let val = String(value[propertyToExtract]).trim();
      if (key === "cpf_cnpj") {
        val = val.replace(/\D/g, "");
      }
      if (val !== "") {
        valuesToProcess.push(val);
      }
    } else if (typeof value === "string" && value.trim() !== "") {
      let val = value.trim();
      if (key === "cpf_cnpj") {
        val = val.replace(/\D/g, "");
      }
      valuesToProcess.push(val);
    } else if (typeof value === "number" || typeof value === "boolean") {
      valuesToProcess.push(String(value));
    }

    if (valuesToProcess.length > 0) {
      if (
        (isAutoCompleteField || key === "id" || key.endsWith("_id")) &&
        valuesToProcess.length > 1
      ) {
        transformedFilters[key] = { $in: valuesToProcess };
      } else {
        const operator =
          key === "id" || key.endsWith("_id") ? "$eq" : "$contains";
        transformedFilters[key] = { [operator]: valuesToProcess[0] };
      }
      return;
    }

    if (
      value !== undefined &&
      value !== null &&
      ((typeof value === "string" && value.trim() !== "") ||
        typeof value === "number" ||
        typeof value === "boolean")
    ) {
      transformedFilters[key] = { $eq: value };
      return;
    }
  });

  if (Object.keys(orConditions).length > 0) {
    transformedFilters.$or = Object.values(orConditions);
  }

  console.log(
    "transformFiltersForUrl - Filtros transformados FINAL:",
    JSON.stringify(transformedFilters, null, 2),
  );
  return transformedFilters;
}
